module.exports = __webpack_public_path__ + "media/backgrounds/francesco-ungaro-wIaARgeF2rE-unsplash-905ff6e5.jpg";